
import Spinner from 'react-bootstrap/Spinner';
import Pagination from 'react-bootstrap/Pagination';

//uuid
import uuid from 'uuid';
import { createElement, useEffect, useState } from 'react';
import Table from 'react-bootstrap/esm/Table';
export const getUUID = ()=>{
    return uuid.v4().replace(/-/g,"");
};

export function Loading(){
    return(
        <div style={{minHeight : 600 , width:"100%"}} className="d-flex align-items-center justify-content-center">
                <Spinner className="mr-1" animation="grow" size="sm" variant="primary"/>
                <Spinner className="mr-1" animation="grow" size="sm" variant="primary"/>
                <Spinner className="mr-1" animation="grow" size="sm" variant="warning"/>
                <Spinner className="mr-1" animation="grow" size="sm" variant="dark"/>
                <Spinner className="mr-1" animation="grow" size="sm" variant="warning"/>
                <Spinner className="mr-1" animation="grow" size="sm" variant="primary"/>
                <Spinner className="mr-1" animation="grow" size="sm" variant="primary"/>
        </div>
    )
  }

export const TBD = false

export function isMemberOf(mygroups = [],group =''){
    return mygroups.indexOf(group) !==-1 ;
}

export function AppPagination({items , active , setIndex}){
    return(
      <Pagination style={{justifySelf : "end"}}>
      {
        [...Array(Math.ceil(items.length / 10)).keys()].map((_item,index)=>{
          return(
            <Pagination.Item key={index} active={index === active}  onClick={()=>setIndex(index)}>
              {index + 1}
            </Pagination.Item>
          )
        })
      }
      </Pagination>
    )
    
}

export const PaginatedTable = ({striped, items , renderRowAs ,renderEmpty, thead,  perPage=10 ,bordered,size}) =>{
  const [active , setActive] = useState(1);
  const [itemsToShow , setMilestones] = useState([]);
  useEffect(()=>{
      const start = (perPage * (active - 1));
      const end = start + (perPage );
      setMilestones(items.slice(start,end));
  },[active, items, perPage]);
  let pageLabels = [];
  for (let number = 1; number <= Math.ceil(items.length / perPage); number++) {
      pageLabels.push(
          <Pagination.Item style={{listStyle : "none"}} className="" key={number} value={number} active={number === active} activeLabel={number} onClick={(e)=>{setActive(parseInt(e.target.getAttribute("value")))}}>
          {number}
          </Pagination.Item>
      );
  }
  return(
              <>
                  <Table striped={striped} hover borderless={!bordered}  bordered={bordered} responsive striped size={size}>
                      <thead className="border-bottom border-secondary">
                      {thead}
                      </thead>
                      <tbody>
                          {
                              itemsToShow.length === 0 ?
                              renderEmpty :
                              itemsToShow.map((item)=>{
                                  return createElement(renderRowAs , {key : item?.id , item})
                              })
                          }
                      </tbody>
                  </Table>
                  <div className="d-flex" style={{justifyContent : "flex-end"}}>
                      {pageLabels}
                  </div>
              </>
          )
}